// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__FcXHl","header":"MainLayout_header__BqDlD","logo":"MainLayout_logo__F35SI"};